<template>
  <div class="previewImage">
    <!-- PhotoSwipe 容器 -->
    <div id="photoSwipeContainer" />
  </div>
</template>
<script>
import PhotoSwipe from 'photoswipe'
import 'photoswipe/dist/photoswipe.css'

export default {
  props: {
    images: {
      type: Array,
      default: () => []
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      photoSwipeInstance: null
    }
  },
  watch: {
    images: {
      handler() {
        this.$nextTick(() => {
          this.initPhotoSwipe()
        })
      },
      immediate: true
    },
    index: {
      handler() {
        this.$nextTick(() => {
          this.initPhotoSwipe()
        })
      },
      immediate: true
    }
  },
  beforeDestroy() {
    // 清理 PhotoSwipe 实例
    if (this.photoSwipeInstance) {
      this.photoSwipeInstance.destroy()
      this.photoSwipeInstance = null
    }
  },
  methods: {
    /**
     * 获取图片真实尺寸
     * @param {string} url - 图片URL
     * @returns {Promise<{width: number, height: number}>}
     */
    getImageDimensions(url) {
      return new Promise((resolve) => {
        const img = new Image()
        img.onload = () => {
          console.log('图片加载成功:', url)
          resolve({
            width: img.naturalWidth,
            height: img.naturalHeight
          })
        }
        img.onerror = () => {
          console.log('图片加载失败:', url)
          // 如果加载失败，使用默认尺寸
          resolve({
            width: 800,
            height: 600
          })
        }
        img.src = url
      })
    },

    /**
     * 初始化 PhotoSwipe
     */
    async initPhotoSwipe() {
      console.log('初始化 PhotoSwipe')
      if (!this.images || this.images.length === 0) {
        return
      }

      try {
        // 动态获取所有图片的真实尺寸
        const imagePromises = this.images.map(async(url, index) => {
          const dimensions = await this.getImageDimensions(url)
          return {
            src: url,
            width: dimensions.width,
            height: dimensions.height,
            alt: `图片 ${index + 1}`
          }
        })

        const images = await Promise.all(imagePromises)

        // 创建 PhotoSwipe 实例
        const options = {
          dataSource: images,
          index: Math.max(0, this.index),
          showHideAnimationType: 'fade',
          showAnimationDuration: 300,
          hideAnimationDuration: 300,
          allowPanToNext: true,
          allowMouseDrag: true,
          allowTouchDrag: true,
          allowVerticalDrag: true,
          allowHorizontalDrag: true,
          pinchToClose: true,
          closeOnVerticalDrag: true,
          closeOnScroll: false,
          closeOnTap: true,
          closeOnTapOutside: true,
          showHideOpacity: true,
          spacing: 0.1,
          bgOpacity: 0.9,
          paddingFn: () => 0,
          // 双击缩放配置
          doubleTapAction: 'zoom',
          // 滚轮缩放配置
          wheelToZoom: true,
          // 缩放配置 - 优化双击缩放体验
          maxZoomLevel: 4, // 降低最大缩放级别，避免过度放大
          minZoomLevel: 0.5, // 提高最小缩放级别，确保图片不会太小
          initialZoomLevel: 'fit', // 初始缩放级别设为fit，让图片完整显示
          // 双击缩放时的目标缩放级别
          doubleTapZoomLevel: 'fill', // 双击时放大到2倍
          // 动画配置
          easing: 'cubic-bezier(0.4, 0, 0.22, 1)',
          // 关闭事件
          close: () => {
            console.log('PhotoSwipe closed')
            this.$emit('closePreview')
          },
          // 缩放事件监听
          beforeZoom: (pswp, zoomParams) => {
            console.log('PhotoSwipe zooming:', zoomParams)
          },
          // 双击缩放事件
          doubleTap: (pswp, point) => {
            console.log('PhotoSwipe double tap at:', point)
          }
        }

        // 销毁之前的实例
        if (this.photoSwipeInstance) {
          this.photoSwipeInstance.destroy()
        }

        // 创建新实例
        this.photoSwipeInstance = new PhotoSwipe(options)
        this.photoSwipeInstance.init()
      } catch (error) {
        console.error('初始化 PhotoSwipe 失败:', error)
        // 如果动态获取尺寸失败，使用默认配置
        this.initPhotoSwipeWithDefaultSize()
      }
    },

    /**
     * 使用默认尺寸初始化 PhotoSwipe（备用方案）
     */
    initPhotoSwipeWithDefaultSize() {
      const images = this.images.map((url, index) => ({
        src: url,
        width: 800,
        height: 600,
        alt: `图片 ${index + 1}`
      }))

      const options = {
        dataSource: images,
        index: Math.max(0, this.index),
        showHideAnimationType: 'fade',
        showAnimationDuration: 300,
        hideAnimationDuration: 300,
        allowPanToNext: true,
        allowMouseDrag: true,
        allowTouchDrag: true,
        allowVerticalDrag: true,
        allowHorizontalDrag: true,
        pinchToClose: true,
        closeOnVerticalDrag: true,
        closeOnScroll: false,
        closeOnTap: true,
        closeOnTapOutside: true,
        showHideOpacity: true,
        spacing: 0.1,
        bgOpacity: 0.9,
        paddingFn: () => 0,
        doubleTapAction: 'zoom',
        wheelToZoom: true,
        maxZoomLevel: 4,
        minZoomLevel: 0.5,
        initialZoomLevel: 'fit',
        doubleTapZoomLevel: 'fill',
        easing: 'cubic-bezier(0.4, 0, 0.22, 1)',
        close: () => {
          console.log('PhotoSwipe closed')
          this.$emit('closePreview')
        }
      }

      if (this.photoSwipeInstance) {
        this.photoSwipeInstance.destroy()
      }

      this.photoSwipeInstance = new PhotoSwipe(options)
      this.photoSwipeInstance.init()
    }
  }
}
</script>
<style scoped>
/* PhotoSwipe 样式已通过 import 引入 */
</style>
